import React, { useEffect, useState } from "react";
import { getUrlParams } from "../../../utils/url";
// @ts-ignore
import { ZoomMtg } from "@zoomus/websdk";
import { useSelector } from "react-redux";
import { AuthState } from "../../../context/auth/auth/reducer";
import { trackParticipantToEvent } from "../../../context/events/action";
import { mapEventToSnippet } from "../../../utils/mapping";
import { useTranslation } from "react-i18next";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {}

declare const window: any;

const ZoomPlayerView = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Gets url params
  const { mn, signature, apiKey, pwd, event, leave } = getUrlParams(document.URL);

  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [pending, setPending] = useState<boolean>(true);
  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[ZoomPlayerView] init");
    document.body.classList.add("zoom-player");

    ZoomMtg.setZoomJSLib('https://dmogdx0jrul3u.cloudfront.net/1.9.1/lib', '/av');
    // Load WebAssembly file
    ZoomMtg.preLoadWasm();
    // Load required JS
    ZoomMtg.prepareJssdk();
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[ZoomPlayerView] destroy");
    document.body.classList.remove("zoom-player");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to user in order to handle meeting join
   */
  useEffect(() => {
    if (user) {
      if (!leave) {
        setPending(true);
        ZoomMtg.init({
          leaveUrl: `${document.URL}&leave=true`,
          isSupportAV: true,
          success() {
            ZoomMtg.join({
              meetingNumber: mn,
              userName: `${user?.firstname} ${user?.lastname}`,
              signature: signature,
              apiKey: apiKey,
              userEmail: user?.email,
              passWord: pwd,
              success() {
                console.log("join meeting success");
                setPending(false);

                try {
                  console.log(event);
                  // Track participant on firestore
                  trackParticipantToEvent(user, mapEventToSnippet(JSON.parse(event)));
                } catch (err) {
                  console.error(err);
                  console.log("cannot track participant to event");
                }
              },
              error(res: any) {
                console.log(res);
                setPending(false);
              },
            });
          },
          error(res: any) {
            console.log(res);
          },
        });
      } else {
        setPending(false);
      }
    }
  }, [user]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div id={"join-room-wrapper"}>
      {leave && (
        <div className={"message"}>
          <h3>{t("pages.eventDetail.zoomPlayer.leave.title")}</h3>
        </div>
      )}
      {pending && <i className={"fas fa-spinner fa-spin loading"} />}
    </div>
  );
};
export default ZoomPlayerView;
